<template>
  <section class="overflow-hidden" id="home">
     <div class="grid lg:grid-cols-2">
        <img :src="S" alt="Logo" class="relative w-full h-full flex items-center justify-center  bg-cover bg-center bg-no-repeat" >
         <div class="absolute h-full w-full inset-0 bg-black/40"></div>
              <div class="w-full relative py-22 h-screen flex items-center px-10 bg-black">
                <div class="text-center text-white">
                    <a href="" class="flex justify-center mx-auto mb-4">
                        <img :src="logo" alt="Logo"  class="h-20">
                    </a>
           <p class="uppercase tracking-widest">حول الموقع</p>
           <h2 class="text-5xl uppercase mb-7">Coming Soon</h2>
           <div class="flex items-center justify-center">
             <p class="lg:w-3/5 text-neutral-300">
حلول الاتصالات السحابية في عالم الأعمال سريع التغيرات،تحتاج الشركات إلى حلول اتصالات ذكية ومرنة لضمان تواصل فعال مع عملائها. شركة تواصل هي الرائدة في تقديم أنظمة الاتصالات السحابية المتطورة متوافقة مع الذكاء الصناعي لتقودك الى نحو تجربة اتصال استثنائية, ،من خلال احدث التقنيات التي تمكنها من إدارة المكالمات والاتصالات بكفاءة، دون الحاجة إلى استثمارات مكلفة في الأنظمة التقليدية. لذلك توفر حلولًا مصممة خصيصًا لمساعدة الشركات على تعزيز علاقاتها مع العملاء
            </p>
           </div>

           <div class="mt-4" dir="rtl">
             <form class="w-full flex items-center justify-center">
               <div class="border rounded-md border-neutral-500 shadow-lg mt-8">
                 <input type="email" name="email" id="email" class="sm:w-96 p-4 border-0 focus:outline-none focus:ring-0 text-sm bg-transparent text-white" placeholder="ادخل بريدك الالكتروني" autocomplete="off" />
                 <button class="py-2 px-6 me-2 border-0 text-white font-semibold text-sm rounded-md bg-neutral-800/60 hover:bg-neutral-800 transition-all duration-500">
                   <div class="flex items-center justify-center gap-1">
                     <p>ارسال</p>
                     <i class="fa-solid fa-arrow-right"></i>
                   </div>
                 </button>
               </div>
             </form>
           </div>

           <div class="relative mt-4 md:mt-12">
             <h6 class="text-xl text-white text-center mb-4">تابعنا</h6>
             <ul class="flex flex-wrap items-center justify-center gap-3">
               <li>
                 <a href="info@tawasell.com" target="_blank" class="h-12 w-12 inline-flex items-center justify-center text-white backdrop-blur-xl bg-white/20 border-2 border-white/40 border-solid text-base rounded-xl transition-all duration-500 group hover:bg-primary hover:text-white">
                   <i class="mdi mdi-email text-xl"></i>
                 </a>
               </li>
               <li>
                 <a href="https://www.linkedin.com/company/tawasell" target="_blank" class="h-12 w-12 inline-flex items-center justify-center text-white backdrop-blur-xl bg-white/20 border-2 border-white/40 border-solid text-base rounded-xl transition-all duration-500 group hover:bg-primary hover:text-white">
                   <i class="mdi mdi-linkedin text-xl"></i>
                 </a>
               </li>
             </ul>
           </div>

           <a href="" class="flex justify-center mx-auto" style="margin-top: 2%;">
             <img :src="n3" alt="N-3" class="h-12">
           </a>

           <p class="opacity-75 text-white text-center pt-20 pb-8" dir="rtl">©
             {{ year }}
             ©  - <a href="https://alinsehartec.com/" target="_blank">صممت من قبل <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-lucide="heart" class="lucide lucide-heart inline h-4 w-4 text-red-500 fill-red-500">
               <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"></path>
             </svg> Alinsehartec </a>
           </p>
         </div>
       </div>
     </div>  
 </section>
</template>
<script setup>
import logo from '@/assets/images/logo.png';
import n3 from '@/assets/images/N-2.png';
import S from '@/assets/images/S1.png';
import { ref} from "vue";
const year = ref(new Date().getFullYear());
</script>